import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "LoggingChange";
let _loggingCategories = void 0;
let _logs = [];
let _lastChange = "";
class LoggingStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getCategories() {
    return _loggingCategories;
  }
  getLogs() {
    return _logs;
  }
  getLastChange() {
    return _lastChange;
  }
}
const store = new LoggingStore();
Dispatcher.register((action) => {
  switch (action.actionType) {
    case actionTypes.LogGetCategories:
      _loggingCategories = action.Result;
      _lastChange = actionTypes.LogGetCategories;
      store.emitChange();
      break;
    case actionTypes.LogGetLogs:
      _logs = action.Result;
      _lastChange = actionTypes.LogGetLogs;
      store.emitChange();
      break;
    default:
  }
});
export default store;
